import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import List from 'material-ui/List/List';
import { Tabs, Tab } from 'material-ui/Tabs';
import ItemParticipant from './ItemParticipant';

const TabsStyle = {
    height: '671px',
    overflow: 'hidden',
    borderBottom: '1px solid #e0e0e0'
};

const ListStyle = {
    height: '623px',
    maxHeight: '100%',
    overflowY: 'auto',
    borderRight: '1px solid #e0e0e0',
    borderBottom: '1px solid #e0e0e0',
    borderLeft: '1px solid #e0e0e0'
};

class TabsParticipants extends Component {
    state = {
        activeTab: 'players'
    };

    handleChange = activeTab => {
        this.setState({ activeTab });
    };

    render() {
        const { activeTab } = this.state;
        const { playerList = [], teamList = [] } = this.props;

        return (
            <Tabs value={activeTab} onChange={this.handleChange} style={TabsStyle}>
                <Tab label="Players" value="players">
                    <List style={ListStyle}>
                        {playerList.map(id => <ItemParticipant key={id} id={id} type="players" />)}
                    </List>
                </Tab>
                <Tab label="Teams" value="teams">
                    <List style={ListStyle}>
                        {teamList.map(id => <ItemParticipant key={id} id={id} type="teams" />)}
                    </List>
                </Tab>
            </Tabs>
        );
    }
}

TabsParticipants.propTypes = {
    // From connect
    playerList: PropTypes.arrayOf(PropTypes.number.isRequired),
    teamList: PropTypes.arrayOf(PropTypes.number.isRequired)
};

export default connect(({ requery = { list: {} } }) => ({
    playerList: requery.list.players,
    teamList: requery.list.teams
}))(TabsParticipants);



/** WEBPACK FOOTER **
 ** ../src/dash/front/grid-maker-tool-page/components/TabsParticipants.js
 **/